import type { FC } from 'react';
import { useRef } from 'react';

import { Container } from '@/components';
import { Breadcrumbs } from '@/components/Breadcrumbs';
import type { Breadcrumb } from '@/components/Breadcrumbs/Breadcrumbs';
import { cn } from '@/utils';

interface BankLayoutHeroProps {
  title: string;
  subtitle: string;
  containerClassName?: string;
  breadcrumbs: Breadcrumb[];
}

const BankLayoutHero: FC<BankLayoutHeroProps> = ({
  title,
  subtitle,
  containerClassName,
  breadcrumbs,
}) => {
  const heroRef = useRef(null);

  return (
    <div
      ref={heroRef}
      className="relative bg-blue-100 bg-bank-pattern bg-cover bg-center bg-no-repeat sm:h-[408px] sm:px-5 lg:mx-4 lg:rounded-2xl lg:px-0"
    >
      <Container
        className={cn(
          'z-20 flex h-full max-w-[1140px] flex-col-reverse gap-12 lg:flex-row lg:gap-6 lg:p-0 lg:px-5 xl:gap-16 xl:px-0',
          containerClassName,
        )}
      >
        <div className="relative z-10 flex h-full max-w-[849px] flex-col items-start justify-between gap-12 py-8">
          <Breadcrumbs breadcrumbs={breadcrumbs} />
          <div className="justify-center">
            <h1 className="h3 md:h2">{title}</h1>
            <p className="mt-1 text-[17px] text-grey-800">{subtitle}</p>
          </div>
          <span className="h-[18px]" />
        </div>
      </Container>
    </div>
  );
};

export default BankLayoutHero;
